import { AppContext } from 'providers/AppConfig';
import { useContext } from 'react';
import { SharedAppRouteConfig } from 'types/app';
import { AppConfig } from './types';

export const useAppContext = () =>
  useContext(AppContext) as AppConfig & SharedAppRouteConfig;

export default AppContext as React.Context<AppConfig & SharedAppRouteConfig>;
